import React, { useState } from 'react';

import { Box, Button, Slide } from '@mui/material';

import TemplatesPanel from '../../../Common/components/Template/TemplatesPanel';
import TemplateTextPanel from '../../../Common/components/Template/TemplateTextPanel';

import {
  initialObjectiveTemplateText,
  initialObjectiveTopics
} from './components/templateData';

import { panelsWrapperSx } from '../../../Common/components/Styles/CommonStyles';

const Objective = () => {
  const [topics, setTopics] = useState(initialObjectiveTopics);

  const [selectedTopicId, setSelectedTopicId] = useState(
    initialObjectiveTopics[0]?.id ?? null
  );

  const [templateText, setTemplateText] = useState(
    initialObjectiveTemplateText
  );

  const selectedTopic =
    topics.find(topic => topic.id === selectedTopicId) || topics[0];

  const selectedTemplateText = templateText[selectedTopicId] || [];

  /*
   * ------------------------------------------------------
   * Add Topic
   * ------------------------------------------------------
   */

  const handleAddTopic = value => {
    const nextId =
      topics.length > 0 ? Math.max(...topics.map(topic => topic.id)) + 1 : 1;

    const newTopic = {
      id: nextId,
      title: value
    };

    setTopics(previous => [...previous, newTopic]);

    setSelectedTopicId(nextId);

    setTemplateText(previous => ({
      ...previous,
      [nextId]: []
    }));
  };

  /*
   * ------------------------------------------------------
   * Edit Topic
   * ------------------------------------------------------
   */

  const handleEditTopic = (topicId, updatedTitle) => {
    setTopics(previous =>
      previous.map(topic =>
        topic.id === topicId
          ? {
              ...topic,
              title: updatedTitle
            }
          : topic
      )
    );
  };

  /*
   * ------------------------------------------------------
   * Add Template Text
   * ------------------------------------------------------
   */

  const handleAddText = value => {
    const currentRows = templateText[selectedTopicId] || [];

    const nextId =
      currentRows.length > 0
        ? Math.max(...currentRows.map(item => item.id)) + 1
        : 1;

    setTemplateText(previous => ({
      ...previous,

      [selectedTopicId]: [
        ...currentRows,
        {
          id: nextId,
          text: value,
          checked: false
        }
      ]
    }));
  };

  /*
   * ------------------------------------------------------
   * Checkbox
   * ------------------------------------------------------
   */

  const handleToggleText = id => {
    setTemplateText(previous => ({
      ...previous,

      [selectedTopicId]: (previous[selectedTopicId] || []).map(item =>
        item.id === id
          ? {
              ...item,
              checked: !item.checked
            }
          : item
      )
    }));
  };

  /*
   * ------------------------------------------------------
   * Edit Template Text
   * ------------------------------------------------------
   */

  const handleEditText = (itemId, updatedText) => {
    setTemplateText(previous => ({
      ...previous,

      [selectedTopicId]: (previous[selectedTopicId] || []).map(item =>
        item.id === itemId
          ? {
              ...item,
              text: updatedText
            }
          : item
      )
    }));
  };

  /*
   * ------------------------------------------------------
   * Reorder Template Text
   * ------------------------------------------------------
   */

  const handleReorderText = reorderedRows => {
    setTemplateText(previous => ({
      ...previous,

      [selectedTopicId]: reorderedRows
    }));
  };

  /*
   * ------------------------------------------------------
   * Save
   * ------------------------------------------------------
   */

  const handleSave = () => {
    const data = {
      topics,
      selectedTopicId,
      templateText
    };

    console.log('Objective Template Save:', data);

    // API call can be added here later
  };

  return (
    <Slide direction="left" in mountOnEnter timeout={200} unmountOnExit>
      <Box
        sx={{
          width: '100%',
          height: '100%',
          minHeight: 0,

          display: 'flex',
          flexDirection: 'column'
        }}>
        {/* Panels */}

        <Box
          sx={{
            flex: 1,
            minHeight: 0
          }}>
          <Box sx={panelsWrapperSx}>
            <TemplatesPanel
              topics={topics}
              selectedTopicId={selectedTopicId}
              onSelectTopic={setSelectedTopicId}
              onAddTopic={handleAddTopic}
              onEditTopic={handleEditTopic}
            />

            <TemplateTextPanel
              title={selectedTopic?.title || 'Template'}
              rows={selectedTemplateText}
              onAddText={handleAddText}
              onToggleText={handleToggleText}
              onEditText={handleEditText}
              onReorderText={handleReorderText}
              showCheckbox={false}
            />
          </Box>
        </Box>

        {/* Save Button */}

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            flexShrink: 0,
            pt: 1.5
          }}>
          <Button
            variant="contained"
            size="small"
            onClick={handleSave}
            sx={{
              minWidth: 80,
              height: 32,
              px: 2.5,

              bgcolor: '#4A90D9',
              color: '#FFFFFF',

              fontSize: 12,
              fontWeight: 500,

              textTransform: 'uppercase',

              '&:hover': {
                bgcolor: '#3C7FC5'
              }
            }}>
            Save
          </Button>
        </Box>
      </Box>
    </Slide>
  );
};

export default Objective;
